import { ProcedureStepFieldValuesAttachmentService as OvermapProcedureStepFieldValuesAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepFieldValuesAttachmentService extends OvermapProcedureStepFieldValuesAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
